import React from "react";

const TodoBox = ({ children }) => {
    return <div className="px-4 py-2 bg-orange-500 text-orange-50 rounded">{children}</div>;
};

export default TodoBox;
